import { CREW_FILE_MAX_BYTES } from '@felix/domain';
import { ApiError, api } from './api.js';
import { tusUpload } from './tus-upload.js';

/**
 * Personel sertifika dosyası ve kontrat belgesi (04.11 notları B5, B6; ADR 0164): dosya tus ile
 * kendi amacıyla yüklenir (sunucu sınırı 10 MB, tür içerikten), sonra belgeye ya da atamaya konur.
 * Yeni dosya eskisini silmez. Açma adresi `Range` destekli ofis ucudur; her açılış kayda geçer.
 */
export const CREW_CERTIFICATE_FILE_UPLOAD_PURPOSE = 'crew_certificate_file';
export const CREW_CONTRACT_FILE_UPLOAD_PURPOSE = 'crew_contract_file';

const id = encodeURIComponent;

async function send(path: string, purpose: string, file: File, owner?: string): Promise<unknown> {
  // Sunucu da denetler; büyük ya da boş dosya hiç gönderilmez
  if (file.size <= 0 || file.size > CREW_FILE_MAX_BYTES) {
    throw new ApiError('FILE_TOO_LARGE', 413);
  }
  const uploadId = await tusUpload(file, {
    purpose,
    ...(owner ? { owner } : {}),
    onProgress: () => undefined,
  });
  return api(path, { method: 'POST', body: { uploadId, fileName: file.name } });
}

export function uploadCrewCertificateFile(certificateId: string, file: File, owner?: string) {
  return send(
    `/office/certificates/${id(certificateId)}/files`,
    CREW_CERTIFICATE_FILE_UPLOAD_PURPOSE,
    file,
    owner,
  );
}

export function uploadCrewContractFile(assignmentId: string, file: File, owner?: string) {
  return send(
    `/office/crew/assignments/${id(assignmentId)}/files`,
    CREW_CONTRACT_FILE_UPLOAD_PURPOSE,
    file,
    owner,
  );
}

export const crewCertificateFileUrl = (fileId: string) =>
  `/api/office/crew-certificate-files/${id(fileId)}`;
export const crewContractFileUrl = (fileId: string) =>
  `/api/office/crew-contract-files/${id(fileId)}`;
